<div class="container h-100">
	<div class="row row-container h-100">
		<div class="col-xs-12 col-sm-7 col-md-6 col-lg-5">
			<div class="container-left">
				<app-header></app-header>
				<main>
					<div class="main-container">
						<div class="row justify-content-sm-center ">
							<div class="col-xs-12">
								<app-title></app-title>
                <div *ngIf="expired" class="alert alert--info-alternative alert--with--icon" role="alert" aria-atomic="true">
                  <span class="icon icon--alert" aria-hidden="true"></span>
                  {{ 'helps.expiration' | translate }}
                </div>
								<router-outlet name="help"></router-outlet>
							</div>
						</div>
					</div>
					<div class="row justify-content-sm-center ">
						<div class="col-xs-12 ">
							<router-outlet name="identification"></router-outlet>
						</div>
					</div>
				</main>
			</div>
		</div>
	</div>
</div>
